export default __webpack_public_path__ + "static/media/img-logo-codership.8de210f2.svg";